import PropTypes from 'prop-types';
import interceptor from 'rest/interceptor';
import when from 'when';
export default interceptor({
    contextTypes: {
        router: PropTypes.object.isRequired,
    },
    request(request) {
        return request;
    },
    response(response) {
        if (response.status.code === 403) {
            this.context.router.push('login');
            return when.reject(response);
        }
        return when(response);
    },
});
